
import {useContext, useEffect, useRef, useState} from "react";
import {appContext} from "../state";
import {message, Typography, Form, Input, Flex, Button, Checkbox, Alert, App, Tabs, InputNumber} from "antd";

import Editor from "./Editor";
import HeadersTabTable from "./requests-list/HeadersTabTable";
import {SyncOutlined} from "@ant-design/icons";
import InputStatusCode from "./inputs/InputStatusCode";
import Clone from "../utils/clone";

function LiveMode(props) {

    //const navigate = useNavigate();
    const {appStateContextValue} = useContext(appContext);
    const [appState, setAppState] = appStateContextValue
    const appStateRef = useRef(appState);
    const [didResize, setDidResize] = useState(null);
    const [statusCode, setResponseStatusCode] = useState(200);
    const [body, setResponseBody] = useState(props.request?.response?.body || {});
    const [responseEditorContentType, setResponseEditorContentType] = useState(props.request?.response?.headers['content-type'] || 'application/json');
    const [headers, setResponseHeaders] = useState(getInitialResponseHeaders());
    const {message, modal, notification} = App.useApp();

    useEffect(() => {
        console.log('MOUNT_LIVE_MODE', props)
    }, []);

    function getInitialResponseHeaders () {
        let headers = Object.keys(props.request?.response?.headers || {}).map((key) => {
            return {key: key, value: props.request?.response?.headers[key]}
        });
        return headers
    }

    function getTabs() {

        let headers = Object.keys(props.request?.request?.headers || {}).map((key) => {
            return {key: key, value: props.request?.request?.headers[key]}
        });
        //console.log('BODY', props.request?.request?.body)

        //  let width = document.querySelector('.view.live-mode.modal .request').getBoundingClientRect().width
        //console.log('width',width)
        const tabs = [
            {
                key: 'body',
                label: 'Body',
                children: props.request?.request?.body ?
                    <Editor key={"live_mode_editor_request_" + props.request?.request?.id} contentType={props.request?.request?.headers['content-type'] || 'application/json'} didResize={didResize} body={props.request?.request?.body}></Editor> : false
            },
            {
                key: 'headers',
                label: 'Headers',
                children: <div>
                    <HeadersTabTable canCopyToclipBoard={true} canEdit={false} headers={headers}></HeadersTabTable>
                </div>,
            }
        ];
        return tabs
    }

    function onHeadersChanged (headers) {
        console.log('onHeadersChanged',headers)
        setResponseHeaders(headers)
    }

    function onAddNewHeader () {
        headers.unshift({key:'sample-header-'+headers.length,value:'value'})
        let headersCloned = Clone(headers)
        setResponseHeaders(headersCloned)
    }

    function getResponseTabs() {
        const tabs = [
            {
                key: 'body',
                label: 'Body',
                children: <>
                    <Editor key={"live_mode_editor_response"} didResize={didResize} contentType={responseEditorContentType} onEditorChanged={onEditorChanged} body={body || {}}></Editor>
                </>
            },
            {
                key: 'headers',
                label: 'Headers',
                children: <div>
                    <HeadersTabTable onHeadersChanged={onHeadersChanged} canEdit={true} headers={headers} onAddNewHeader={onAddNewHeader}></HeadersTabTable>
                </div>,
            }
        ];
        return tabs
    }

    const onRequestTabChange = (key) => {
        console.log(key);
    }

    const onResponseTabChange = (key) => {
        console.log(key);
    }

    function onEditorChanged(newBody) {
        setResponseBody(newBody)
    }

    function respondToLiveModeRequest() {
        if (props.onRespondToLiveModeRequest) {
            //console.log('headers',headers)
            let headersAsMap = convertHeadersBackToKeyMap(headers)
            message.open({type: 'success', content: 'Response was sent!'});
            props.onRespondToLiveModeRequest({headers:headersAsMap,body:body,statusCode:statusCode})
        }
    }

    function convertHeadersBackToKeyMap (headers) {
        let headersMap = {}
        headers.forEach( (header) => {
            headersMap[header.key] = header.value
        })
        return headersMap
    }

    function ignoreToLiveModeRequest () {
        if (props.onIgnoreLiveModeRequest) {
            props.onIgnoreLiveModeRequest()
        }
    }

    function onStatusCodeChanged (newStatusCode,isValid) {
        if (isValid) {
            setResponseStatusCode(newStatusCode)
        }
    }

    const statusCodeInfo = <div className="tab-bar-extra">
        <InputStatusCode statusCode={statusCode} onChange={onStatusCodeChanged}></InputStatusCode>
    </div>

    return (
        <>
            <div className="request">
                <div className="header">Request</div>
                <Tabs defaultActiveKey="1" items={getTabs()} onChange={onRequestTabChange}></Tabs>
            </div>
            <div className="response">
                <div className="header">Response</div>
                <Tabs defaultActiveKey="1" items={getResponseTabs()} onChange={onResponseTabChange}
                      tabBarExtraContent={statusCode !== '' ? statusCodeInfo : false}></Tabs>
                <SyncOutlined className="spinner" spin/>
                <div className="button-group">
                    <Button onClick={ignoreToLiveModeRequest} className="ignore-to-live-mode"
                            type="secondary">Ignore</Button>
                    <Button onClick={respondToLiveModeRequest} className="respond-to-live-mode"
                            type="primary">Respond</Button>
                </div>
            </div>
        </>
    )
}

export default LiveMode;
